import BookingWidget from "@/components/BookingWidget";

export default function BookingEngine() {
  return (
    <div className="jt-container py-14">
      <div className="jt-eyebrow mb-3">Safari booking engine</div>
      <h1 className="font-serif text-4xl text-[#1E3A2B] mb-8">Build your Jawai safari</h1>
      <div className="max-w-5xl">
        <BookingWidget />
      </div>
    </div>
  );
}
